export class ParameterTypes {
}
ParameterTypes.String = '';
ParameterTypes.StringArray = [];
ParameterTypes.Boolean = false;
ParameterTypes.BooleanArray = [];
ParameterTypes.Number = 0;
ParameterTypes.NumberArray = [];
ParameterTypes.Date = new Date();
ParameterTypes.DateArray = [];
